import { defineMessages } from 'react-intl';
import type { LocalePerProduct } from 'contracts';

const seo: LocalePerProduct = {
  livejasmin: defineMessages({
    title: {
      id: 'pages.profile.profilePhoto.seo.livejasmin.title',
      defaultMessage: 'Profile Photo',
    },
    description: {
      id: 'pages.profile.profilePhoto.seo.livejasmin.description',
      defaultMessage: 'Model Center - Profile Photo',
    },
  }),
  oranum: defineMessages({
    title: {
      id: 'pages.profile.prices.seo.oranum.title',
      defaultMessage: 'Profile Photo',
    },
    description: {
      id: 'pages.profile.prices.seo.oranum.description',
      defaultMessage: 'Broadcaster Center - Profile Photo',
    },
  }),
};

export default {
  pages: {
    profile: {
      profilePhoto: {
        seo,
        tabs: {
          ...defineMessages({
            main: {
              id: 'pages.profile.profilePhoto.tabs.main',
              defaultMessage: 'Main',
            },
            nonExplicit: {
              id: 'pages.profile.profilePhoto.tabs.nonExplicit',
              defaultMessage: 'Non-Explicit',
            },
          }),
        },
        navigationMenu: {
          ...defineMessages({
            label: {
              id: 'pages.profile.profilePhoto.navigationMenu.label',
              defaultMessage: 'Profile Photo',
            },
          }),
        },
      },
    },
  },
};
